'use strict';

/**
 * @author Maxim Seredkin
 * @return {*}
 */
export default function projectInvestorCountry() {
    return {
        restrict: 'A',
        template: require('../view/project-investor-country.html'),
        scope: {
            project: '=myProject',
            edit: '=?edit',
        },
        controller: ['$scope', 'InvestorCountryService', 'CountryService',
            function($scope, InvestorCountryService, CountryService) {
                $scope.changeInvestorSearchRequired = changeInvestorSearchRequired;

                init();

                // region Function

                /**
                 * Инициализация
                 */
                function init() {
                    InvestorCountryService.api.get(null, (data) => {
                        $scope.investorCountries = data._embedded;
                        if (Array.isArray(data._embedded)) {
                            $scope.investorCountries.unshift({
                                id: undefined,
                                name: "Не требуется",
                                specified: false,
                                status: "ENABLED"
                            })
                        }
                    });
                    CountryService.api.get(null, (data) => $scope.countries = data._embedded);
                }

                /**
                 * Событие изменения флага "Требуется инвестор"
                 * @param {*} investorSearchRequired
                 */
                function changeInvestorSearchRequired(investorSearchRequired) {
                    if (!$scope.edit) return;
                    $scope.project.investorSearchRequired = investorSearchRequired;

                    if (investorSearchRequired) return;

                    $scope.project.investorCountry = null;
                    $scope.project.investorCountryClass = {};
                }

                // endregion
            }],
    };
}
